// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__jReGA","upload":"Small_upload__2MRSI","imageWrap":"Small_imageWrap__1XnRr","removeBtn":"Small_removeBtn__t1rne"};